import VueRouter from "vue-router";
import IndexView from "@/views/index.vue";
import SitemapView from "@/views/Sitemap.vue";

export const routes = [
  {
    path: "/",
    name: "index",
    component: IndexView,
  },
  {
    path: "/sitemap",
    name: "sitemap",
    component: SitemapView,
  }
];

export default new VueRouter({
  // mode: "history",
  routes,
});
